import { useState, useEffect } from 'react'
import { Box, Tab, Tabs } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import ExternalUsers from './ExternalUsers'
import InternalUsers from './InternalUsers/InternalUsers'
import BoxWrapper from '../../../components/BoxWrapper'
import { SpaceDivider } from './accounts.styles'
import { CustomTabPanel } from '../../../components/CustomTabPanel'

const ACCOUNTS_TABS = [
  { id: 0, label: 'Internal users', path: '/internal' },
  { id: 1, label: 'External users', path: '/external' },
] as const

const Accounts = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const [value, setValue] = useState(0)
  const a11yProps = (index: number) => {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    }
  }

  const handleTabChange = (_e, v) => {
    const selectedTab = ACCOUNTS_TABS[v]

    navigate(`/accounts${selectedTab.path}`)
  }

  useEffect(() => {
    const tabPath = location.pathname.split('/accounts')[1] || ''
    const foundTab = ACCOUNTS_TABS.findIndex((tab) => tab.path === tabPath)
    if (foundTab >= 0) {
      setValue(foundTab)
    } else {
      setValue(0)
    }
  }, [location.pathname])

  return (
    <div>
      <BoxWrapper>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleTabChange}>
            <Tab label="ّInternal Users" {...a11yProps(0)} />
            <Tab label="External Users" {...a11yProps(1)} />
          </Tabs>
        </Box>
        <SpaceDivider />

        <CustomTabPanel value={value} index={0}>
          <InternalUsers />
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <ExternalUsers />
        </CustomTabPanel>
      </BoxWrapper>
    </div>
  )
}

export default Accounts
